export const fontFamily = {
  primaryFont: "'Signika', sans-serif",
  secondaryFont: "'Open Sans Condensed', Arial",
};
